const PROFILE_INFO_GRID_CLASS_NAME = 'profile-info-grid';
const DASHED_DROPZONE_GRID_CLASS_NAME = 'dashed-dropzone';

export {
  PROFILE_INFO_GRID_CLASS_NAME,
  DASHED_DROPZONE_GRID_CLASS_NAME,
};
